<template>
  <div>
    <filters-form @filtersSubmited="onFiltersSubmited" />

    <el-data-table
      :resourceUrl="baseUrl"
      :externalFiltersValid="filters.valid || false"
      ref="dataTable"
    >
      <template slot="tableActions">
        <a
          :disabled="downloadUrl == null"
          slot="top-buttons"
          class="btn btn-default btn-sm"
          @click="downloadReport()"
          ><i class="fa fa-download"></i> Download</a
        >
      </template>

      <template slot="columns" slot-scope="scope">
        <el-table-column
          prop="employee_company_id_number"
          width="80"
          align="right"
          label="Código"
        >
        </el-table-column>
        <el-table-column prop="employee_name" label="Empleado">
        </el-table-column>
        <el-table-column prop="functional_area_description" label="Área">
        </el-table-column>
        <el-table-column prop="title" label="Puesto"> </el-table-column>

        <el-table-column
          v-for="field in scope.header"
          :key="field"
          width="60"
          align="right"
          class-name="table-header"
          :label="field"
        >
          <template slot-scope="row_scope">
            {{ row_scope.row[field] }}
          </template>
        </el-table-column>

        <el-table-column
          prop="monthly_salary"
          width="80"
          align="right"
          label="Salario"
        >
          <template slot-scope="row_scope">
            {{ numberFormat.format(row_scope.row["monthly_salary"] || 0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="total_surcharge_and_extra"
          width="80"
          align="right"
          label="Recargos Hs Extra"
        >
          <template slot-scope="row_scope">
            {{
              numberFormat.format(row_scope.row["total_surcharge_and_extra"] || 0)
            }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="showBonuses"
          prop="bonus"
          width="110"
          align="right"
          label="Bonificación"
        >
          <template slot-scope="row_scope">
            {{ numberFormat.format(row_scope.row["bonus"] || 0) }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="showBonuses"
          prop="bonus_observation"
          width="180"
          label="Descripción Bonificación"
        >
          <template slot-scope="row_scope">
            {{ row_scope.row["bonus_observation"] }}
          </template>
        </el-table-column>
        <el-table-column prop="total" width="80" align="right" label="Total">
          <template slot-scope="row_scope">
            {{ numberFormat.format(row_scope.row["total"] || 0) }}
          </template>
        </el-table-column>
      </template>
    </el-data-table>
  </div>
</template>

<script>
import filters_form from "./filters-form.vue";
import el_data_table from "../el-data-table.vue";
export default {
  data() {
    return {
      baseUrl: "/reports/hoursworkedonerow",
      queryString: null,
      downloadUrl: null,
      filters: {},
      numberFormat: new Intl.NumberFormat("es-CO", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "COP",
      }),
    };
  },
  computed: {
    showBonuses() {
      if (this.$auth && this.$auth.user && this.$auth.user.profile && this.$auth.user.profile.show_bonuses) {
        return true;
      }
      if (this.$auth && this.$auth.config && (this.$auth.config.show_bonuses || (this.$auth.config.client_config && this.$auth.config.client_config.show_bonuses))) {
        return true;
      }
      return window.sync_config && (window.sync_config.show_bonuses === true || (window.sync_config.client_config && window.sync_config.client_config.show_bonuses === true));
    }
  },
  watch: {
    $route: function (to) {
      this.setDownloadUrl();
    },
  },
  mounted: function () {
    this.setDownloadUrl();
  },
  components: {
    "filters-form": filters_form,
    "el-data-table": el_data_table,
  },
  methods: {
    onFiltersSubmited(filters) {
      // console.log(filters);
      this.filters = filters;
    },
    setDownloadUrl: function () {
      // console.log(this.$route);
      this.queryString = $.param(this.$route.query);
      if (
        this.$route.query.date_from != undefined &&
        this.$route.query.date_to != undefined &&
        this.$route.query.date_from != null &&
        this.$route.query.date_to != null
      ) {
        this.downloadUrl =
          "/api" + this.baseUrl + "/download?" + this.queryString;
      } else {
        this.downloadUrl = null;
      }
    },
    downloadReport: function () {
      if (this.downloadUrl != null) {
        window.location.href =
          this.downloadUrl + "&token=" + localStorage.getItem("id_token");
      }
    },
  },
};
</script>
<style>
.table-header {
  font-size: 10px;
}
</style>